import withNavigationTheme from '../../hooks/withNavigationTheme';
import TopNavigationSidebarHeader from './TopNavigationSidebarHeader';

export default withNavigationTheme(TopNavigationSidebarHeader);
